export const ID = 'id';
export const CREATIVES = 'creatives';
export const REQUESTED_BY = 'requestedById';
export const JIRA_TASK = 'jiraTask';
export const DESIGNER = 'authorId';
export const BUSINESS_PARTNERS = 'businessPartnerIds';
export const CREATIVE_TYPE = 'creativeTypeId';
export const COLOR = 'colorId';
export const ENHANCERS = 'enhancerIds';
export const NETWORKS = 'networkIds';
export const TAGS = 'tagIds';
export const INHERIT_TAGS = 'inheritTagIds';
export const CHANNELS = 'channelIds';
export const POSTFIX = 'postfix';
export const OS = 'osId';
export const LANGUAGE = 'languageId';
export const DESCRIPTION = 'description';
export const APPLICATION = 'applicationId';
export const FILE = 'file';
export const FILE_GUID = 'fileGUID';
export const CONCEPT_ID = 'conceptId';
export const YOUTUBE_LINK = 'youtubeLink';
export const SOUND_ID = 'soundId';
export const OUTSOURCE_STUDIO_ID = 'outsourceStudioId';
export const EXCLUSIVE_FOR_AFFILIATES = 'exclusiveForAffiliateIds';
export const TESTED = 'tested';
export const AI_GENERATED = 'isAICreated';
export const PRODUCTION_TYPE = 'productionTypeId';
